<template>
  <div>
    <div ref="editor" class="editor-wrapper"></div>
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      style="height: 500px; overflow-y: hidden;border-bottom: 1px solid #ccc"
      v-model="html"
      disabled
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      @onChange="onChange"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import projectConfig from '@/core/config'
// import {getFileId ,getFile} from '@/api/email'
import { Email } from '@/api/email'
export default ({
    components: { Editor, Toolbar },
    props: {
      value: {
        type: String
      },
      disabled:{
        type:Boolean,
        default:false
      }
    },
    data () {
        const that = this
        return {
            editor: null,
            html: '',
            toolbarConfig: {
              excludeKeys: [
                  'emotion',
                  'fullScreen',
                  'codeBlock',
                  'group-video'
                  // 'group-more-style' // 排除菜单组，写菜单组 key 的值即可
              ]
            },
            editorConfig: {
              placeholder: '请输入内容...',
              MENU_CONF: {
                uploadImage: {
                  headers: {
                      Authorization: localStorage.getItem('token')
                  },
                  server: projectConfig.baseUrl + 'admin/online/onlineOperation/uploadDatasource/oaEmailFile',
                  allowedFileTypes: ['.jpg', '.jpeg', '.png', '.bmp', '.gif'],
                  fieldName: 'uploadFile',
                  maxFileSize: 5 * 1024 * 1024, // 20
                  MwithCredentials: true,
                  maxNumberOfFiles: 1,
                  meta: {
                      datasourceId: '1697212133265117185',
                      fieldName: 'file_name',
                      asImage: false
                  },
                  // 上传之前触发
                  onBeforeUpload (file) { // JS 语法
                    return file
                  },
                  // 上传进度的回调函数
                  onProgress (progress) { // JS 语法
                      // progress 是 0-100 的数字
                      console.log('progress', progress)
                  },
                  // 单个文件上传成功之后
                  onSuccess (file, res) { // JS 语法
                    console.log(file,112233)
                    console.log(`${file.name} 上传成功`, res)
                  },
                  // 单个文件上传失败
                  onFailed (file, res) { // JS 语法
                    that.$message.error('文件上传错误')
                    console.log(`${file.name} 上传失败`, res)
                  },
                  // 上传错误，或者触发 timeout 超时
                  onError (file, err, res) { // JS 语法
                    that.$message.error('文件上传错误')
                    console.log(`${file.name} 上传出错2`, err, res, that)
                  },
                  customInsert (res, insertFn) { // JS 语法
                  console.log(res, insertFn);
                    // res 即服务端的返回结果
                    // 从 res 中找到 url alt href ，然后插入图片
                    const oaEmailFileDto = {
                      fileName: res.data.filename,
                      originalName: '[图片]'
                    }
                    Email.getFileId(that,{oaEmailFileDto}).then(rs => {
                        const url = projectConfig.baseUrl + '/admin/online/onlineOperation/noAuthDownloadDatasource/oaEmailFile?datasourceId=1697212133265117185&fieldName=file_name&asImage=false&dataId=' + rs.data + '&filename=' + res.data.filename + '&MenuId=1631159779164426240'
                        insertFn(url, res.data.filename)
                    })
                  }
                }
              }
            },
            mode: 'default' // or 'simple'
        }
    },
    watch: {
      value :{
        deep:true,
        immediate:true,
        handler(val){
          if(val !== "<p><br></p>"){
           this.html = val
          }
        }
      }
    },
    methods: {
        onCreated (editor) {
          this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
          console.log(this.disabled);
          if(this.disabled){
            this.editor.disable()
          }
        },
        onChange (edit) {
          if(edit.getHtml().length < 30 && edit.getText() === ''){
            this.$emit('change', '', '')
          } else {
            this.$emit('change', edit.getHtml(), edit.getText())
          }
        },
        setInnerHtml(html){
          this.html = html
        }
    },
    beforeDestroy () {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
.ant-editor-wang {
  .editor-wrapper {
    text-align: left;
  }
  .w-e-text-container{
    height: 550px !important;
  }
}
.w-e-modal button {
  line-height:20px !important;
}
.history{
  .w-e-toolbar{
    display: none !important;
  }
}
</style>
